export var Colors;
(function (Colors) {
    Colors["BackgroundDefault"] = "rgba(255, 255, 255, 1)";
    Colors["BackgroundDefaultDisabled"] = "rgba(223, 223, 223, 1)";
    Colors["BackgroundDefaultHover"] = "rgba(21, 21, 21, 0.1)";
    Colors["BackgroundDefaultSelected"] = "rgba(255, 240, 239, 1)";
    Colors["BackgroundSecondary"] = "rgba(20, 22, 25, 1)";
    Colors["Primary"] = "rgba(219, 60, 0, 1)";
    Colors["PrimaryHover"] = "rgba(149, 48, 0, 1)";
    Colors["PrimaryTransparent"] = "rgba(219, 60, 0, 0.5)";
    Colors["TextDefault"] = "rgba(21, 21, 21, 1)";
    Colors["TextDefaultDisabled"] = "rgba(140, 140, 140, 1)";
    Colors["TextSecondary"] = "rgba(255, 255, 255, 1)";
})(Colors || (Colors = {}));
//# sourceMappingURL=colors.js.map